var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "vtuber"
  }, [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("Function", {
    attrs: {
      title: "产品功能",
      adslist: _vm.adsList,
      itemcls: true
    }
  }), _c("section", {
    staticClass: "vtuber_advantages"
  }, [_c("div", {
    staticClass: "ads-main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "产品优势"
    }
  }), _c("div", {
    staticClass: "ads-wrapper"
  }, [_c("div", {
    staticClass: "left"
  }, _vm._l(_vm.leftItems, function (item, index) {
    return _c("div", {
      key: index,
      class: ["left_item", {
        "left_item--active": _vm.activeIndex === index
      }],
      on: {
        click: function ($event) {
          return _vm.changeActive($event, index);
        }
      }
    }, [_c("img", {
      staticClass: "left-bg",
      attrs: {
        src: item.bgImg,
        alt: "bgimg"
      }
    }), _c("img", {
      staticClass: "title-img",
      attrs: {
        src: _vm.activeIndex === index ? item.activeImg : item.img,
        alt: "left-img"
      }
    }), _c("p", {
      staticClass: "litem-title"
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0), _vm.rightItems.length > 0 ? _c("div", {
    staticClass: "right"
  }, _vm._l(_vm.rightItems, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "right_item"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "right-img"
      }
    }), _c("div", {
      staticClass: "ritem-title"
    }, [_c("p", [_vm._v(_vm._s(item.title))])]), _c("p", {
      staticClass: "ritem-desc"
    }, [_vm._v(_vm._s(item.desc))])]);
  }), 0) : _vm._e()])], 1)]), _c("section", {
    staticClass: "vtuber_applications"
  }, [_c("div", {
    staticClass: "vtuber_applications_main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "应用场景"
    }
  }), _c("ul", {
    staticClass: "list"
  }, _vm._l(_vm.applicationList, function (item, index) {
    return _c("li", {
      key: index
    }, [_c("img", {
      staticClass: "icon-strengths",
      attrs: {
        src: item.img,
        alt: "strengths"
      }
    }), _c("div", {
      staticClass: "item-content"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("p", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])]), _c("img", {
      staticClass: "list-img",
      attrs: {
        src: require("@/assets/images/components/translation-app-bg.png"),
        alt: "translation-app-bg"
      }
    })]);
  }), 0)], 1)]), _c("section", {
    staticClass: "vtuber_broker-bg"
  }, [_c("div", {
    staticClass: "broker-main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "他们都选择了同花顺AI虚拟人"
    }
  }), _c("div", {
    staticClass: "card-main"
  }, _vm._l(_vm.cardList, function (item, index) {
    return _c("BrokerCard", {
      key: index,
      attrs: {
        url: item.url,
        text: item.text
      }
    });
  }), 1)], 1)]), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };